import { toUnits } from './format';

const BATCH_SIZE = 150;

// Lightweight CSV line splitter (handles simple quoted fields).
function splitLine(line) {
  const out = [];
  let cur = '';
  let inQuotes = false;
  for (let i = 0; i < line.length; i++) {
    const c = line[i];
    if (c === '"') { inQuotes = !inQuotes; continue; }
    if (c === ',' && !inQuotes) { out.push(cur); cur = ''; continue; }
    cur += c;
  }
  out.push(cur);
  return out.map((s) => s.trim());
}

// Find a column index by fuzzy header name.
function findCol(headers, needles) {
  const lower = headers.map((h) => h.toLowerCase());
  for (const n of needles) {
    const idx = lower.findIndex((h) => h.includes(n));
    if (idx !== -1) return idx;
  }
  return -1;
}

/**
 * Parse the trading CSV text into rows of { account, profitRaw, profitUnits }.
 * Skips header, blank rows, rows with 0 / negative / missing profit,
 * and rows without a numeric account number.
 */
export function parseTradingCsv(text) {
  const lines = text.split(/\r?\n/).filter((l) => l.trim() !== '');
  if (lines.length < 2) return { rows: [], skipped: 0, headerErr: 'CSV is empty' };

  const headers = splitLine(lines[0]);
  const accCol = findCol(headers, ['account number', 'account', 'mt5', 'login']);
  const profitCol = findCol(headers, ['closed profit', 'profit', 'pnl']);

  if (accCol === -1 || profitCol === -1) {
    return { rows: [], skipped: 0, headerErr: 'Could not find Account Number / Closed Profit columns' };
  }

  const rows = [];
  let skipped = 0;

  for (let i = 1; i < lines.length; i++) {
    const cells = splitLine(lines[i]);
    const accStr = (cells[accCol] || '').replace(/[^0-9]/g, '');
    const profitStr = (cells[profitCol] || '').replace(/[^0-9.\-]/g, '');
    const profitNum = Number(profitStr);

    if (!accStr || isNaN(profitNum) || profitNum <= 0) { skipped++; continue; }

    rows.push({
      account: accStr,
      profitRaw: profitNum,
      profitUnits: toUnits(profitStr),
    });
  }

  return { rows, skipped, headerErr: null };
}

// Slice rows into batches of 150 (account[], profit[] arrays ready for the contract).
export function chunkForDistribution(rows) {
  const batches = [];
  for (let i = 0; i < rows.length; i += BATCH_SIZE) {
    const slice = rows.slice(i, i + BATCH_SIZE);
    batches.push({
      accounts: slice.map((r) => r.account),
      profits: slice.map((r) => r.profitUnits),
      count: slice.length,
    });
  }
  return batches;
}

export { BATCH_SIZE };
